import React from 'react';
import { Link } from 'react-router-dom';
import {
  Box,
  Heading,
  Text,
  Button as ChakraButton,
  VStack,
  Flex
} from '@chakra-ui/react';

const LandingPage = () => {
  return (
    <Flex
      minH="100vh"
      align="center"
      justify="center"
      bgGradient="linear(to-r, blue.500, teal.500)"
      color="white"
      p={4}
    >
      <Box
        bg="white"
        color="gray.800"
        p={10}
        rounded="lg"
        shadow="lg"
        textAlign="center"
        maxW="md"
        w="full"
      >
        <Heading mb={4} fontSize="3xl" color="blue.600">
          Welcome to TrustGrid DAPP
        </Heading>
        <Text mb={6} fontSize="md" color="gray.600">
          Secure & seamless login using QR codes.
        </Text>
        <VStack spacing={4}>
          <Link to="/signup" style={{ width: '100%' }}>
            <ChakraButton colorScheme="blue" w="full">
              Sign Up
            </ChakraButton>
          </Link>
          <Link to="/login" style={{ width: '100%' }}>
            <ChakraButton variant="outline" colorScheme="blue" w="full">
              Login
            </ChakraButton>
          </Link>
        </VStack>
      </Box>
    </Flex>
  );
};

export default LandingPage;
